import React, { useEffect, useState } from "react";
import "../../Styles/DeactivateUsers.css";
import Loader from "../../Components/Loader";

function ActiveUsers() {
  const [admins, setAdmins] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("No authentication token found");
          return;
        }
        setLoading(true);
        const response = await fetch(
          "https://api.uniums.com/api/User/active-admins",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        if (response.ok) {
          setAdmins(data.admins);
          setFilteredAdmins(data.admins);
        } else {
          console.error("Failed to fetch admins:", data.message);
        }
      } catch (error) {
        console.error("Error fetching admins:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAdmins();
  }, []);
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = admins.filter(
      (admin) =>
        admin.name.toLowerCase().includes(value) ||
        admin.email.toLowerCase().includes(value) ||
        admin.organizationName.toLowerCase().includes(value) ||
        admin.organizationAddress.toLowerCase().includes(value) ||
        admin.organizationContact.toLowerCase().includes(value)
    );
    setFilteredAdmins(filtered);
  };
  if (loading) {
    return <Loader />;
  }

  return (
    <div className="DeactivateUsers_container">
      <h1>Activate Admins</h1>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by Name, Email, or Organization"
          value={searchTerm}
          onChange={handleSearch}
          className="search-box"
        />
      </div>

      <div className="admin-table-container">
        <table className="DeactivateUsers_table">
          <thead>
            <tr>
              <th>SL No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Organization Name</th>
              <th>Organization Address</th>
              <th>Contact</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredAdmins.map((admin, index) => (
              <tr key={admin._id}>
                <td>{index + 1}</td>
                <td>{admin.name}</td>
                <td>{admin.email}</td>
                <td>{admin.organizationName}</td>
                <td>{admin.organizationAddress}</td>
                <td>{admin.organizationContact}</td>
                <td className="active_td">
                  {admin.active ? "Active" : "Active"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ActiveUsers;
